const COPYRIGHT_TIME_ZONE = 'Pacific/Auckland' as const

export function sugarGremlinCopyright(now = new Date()) {
  const year = new Intl.DateTimeFormat('en-NZ', {
    timeZone: COPYRIGHT_TIME_ZONE,
    year: 'numeric',
  }).format(now)
  return `© ${year} Sugar Gremlin. All rights reserved.`
}
